import React from 'react';

const CryptoFuturesStar = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M11.3272 2.11176C11.271 1.94304 11.1241 1.81806 10.9491 1.79307L9.58063 1.5931L8.96511 0.321443C8.80889 -0.000376858 8.28085 -0.000376858 8.12463 0.321443L7.51224 1.5931L6.14372 1.79307C5.96563 1.81806 5.8219 1.94304 5.76566 2.11176C5.70942 2.28048 5.75629 2.46795 5.88439 2.59293L6.87484 3.55839L6.64051 4.92378C6.60926 5.09875 6.68113 5.27685 6.82798 5.38308C6.9717 5.48931 7.16542 5.50181 7.32164 5.41745L8.54643 4.77381L9.77122 5.41745C9.92745 5.49868 10.118 5.48931 10.2649 5.38308C10.4086 5.27685 10.4805 5.10188 10.4524 4.92378L10.218 3.55839L11.2085 2.59293C11.3366 2.46795 11.3834 2.28048 11.3272 2.11176Z",
      fill: "#FFD205"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M15.1393 8.52553C14.3644 8.52553 13.7333 9.15667 13.7333 9.93154C13.7333 10.5408 14.127 11.0563 14.6706 11.2501V14.1808L12.796 11.65V7.50383C13.3396 7.31011 13.7333 6.79458 13.7333 6.18531C13.7333 5.41044 13.1021 4.7793 12.3273 4.7793C11.5524 4.7793 10.9213 5.41044 10.9213 6.18531C10.9213 6.57899 11.0837 6.93205 11.3431 7.18826C9.62462 8.12248 7.46561 8.12248 5.74716 7.18826C6.00649 6.93205 6.16896 6.57899 6.16896 6.18531C6.16896 5.41044 5.53782 4.7793 4.76295 4.7793C3.98808 4.7793 3.35694 5.41044 3.35694 6.18531C3.35694 6.79458 3.75062 7.31011 4.29428 7.50383V11.6531L2.4196 14.1839V11.2532C2.96326 11.0595 3.35694 10.5439 3.35694 9.93467C3.35694 9.1598 2.7258 8.52866 1.95093 8.52866C1.17606 8.52866 0.544922 9.1598 0.544922 9.93467C0.544922 10.5439 0.938605 11.0595 1.48226 11.2532V15.5899C1.48226 15.8555 1.72285 16.0586 1.95093 16.0586H15.1362C15.3518 16.0586 15.6048 15.8618 15.6048 15.5899V11.2532C16.1485 11.0595 16.5422 10.5439 16.5422 9.93467C16.5453 9.15667 15.9142 8.52553 15.1393 8.52553ZM11.8586 11.3376H5.23475V7.96625C6.2502 8.5349 7.4125 8.83173 8.54668 8.83173C9.68086 8.83173 10.8432 8.5349 11.8586 7.96625V11.3376Z",
      fill: "currentColor"
    }
  )
);

export { CryptoFuturesStar };
//# sourceMappingURL=CryptoFuturesStar.js.map
